import Navigation from './Navigation';

export default function Header( { currentPage, handlePageChange } ) {

	return (
		<header>
			<h1>Domiltan Nguyen</h1>
			<Navigation currentPage={currentPage} handlePageChange={handlePageChange}/>
		</header>
	);
}